import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { exchangeSession, usePremium } from "@/context/PremiumContext";

// Handles the OAuth return: reads session_id from the URL fragment, exchanges it
// for a session cookie, then redirects to the account page.
export default function AuthCallback() {
  const navigate = useNavigate();
  const premium = usePremium();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    (async () => {
      if (m) {
        try {
          const data = await exchangeSession(decodeURIComponent(m[1]));
          premium && premium.setUser && premium.setUser(data);
        } catch (e) {
          console.debug("Échange de session échoué — utilisateur non connecté:", e);
        }
      }
      window.history.replaceState(null, "", window.location.pathname);
      if (premium && premium.refresh) await premium.refresh();
      navigate("/compte", { replace: true });
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex h-screen items-center justify-center bg-background text-sm text-muted-foreground" data-testid="auth-callback">
      Connexion en cours…
    </div>
  );
}
